import { Collapse, Popconfirm } from "antd";
import Checkbox, { CheckboxChangeEvent } from "antd/lib/checkbox/Checkbox";
import GoogleMap from 'google-map-react';
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { GOOGLEMAP_API_KEY } from "../../../../constants/constants";
import { DashboardRAPMDataModel, DashboardRAPMModel } from "../../../../models/dashboad/dashboard.model";
import { AMOUNT_UTIL } from "../../../../utils/amount.utils";
import { getCurrentLang } from "../../../../utils/i18n";
import { LocationIcon } from "../../../atoms/icon";
import "./ecap-dashboard-rapm.scss";

const { Panel } = Collapse;

const GOOGLE_MAP_SETTINGS = {
    zoom: 8,
    zoomControl: true,
    fullscreenControl: true,
    center: {
        lat: 0,
        lng: 0
    }
}

interface Props {
    data: DashboardRAPMModel[]
}

const DashboardRapmComponent = (props: Props) => {

    const { t } = useTranslation();
    const [data, setData] = useState<DashboardRAPMModel[]>([]);
    const [markers, setMarkers] = useState<DashboardRAPMDataModel[]>([]);
    const [isCollapse, setIsCollapse] = useState(false);
    const [center, setCenter] = useState(GOOGLE_MAP_SETTINGS.center);

    const inintMarkers = (values: DashboardRAPMModel[]) => {
        let markersData: DashboardRAPMDataModel[] = [];
        values.forEach(item => {

            item.data.forEach(pc => {
                const existedItem = markersData.find(x => x.postal_code === pc.postal_code);
                pc.data.map(x => {
                    x.segment = item.segment;
                    return x;
                })

                if (existedItem) {
                    existedItem.data = [...pc.data, ...existedItem.data]
                } else {
                    markersData.push(pc);
                }
            })

            markersData = [...markersData, ...getMarkers(item)];
        })

        setMarkers(markersData);
    }

    const getMarkers = (value: DashboardRAPMModel) => {
        const markersData: DashboardRAPMDataModel[] = [];
        value.data.forEach(d => {
            if (validateLatAndLng(d.lat, d.long)) {
                d.color = value.markerColor;
                markersData.push(d);
            }
        })

        return markersData;
    }

    const validateLatAndLng = (lat: number, lng: number) => {
        return isFinite(lat) && Math.abs(lat) <= 90 && isFinite(lng) && Math.abs(lng) <= 180;
    }

    const checkBoxChange = (e: CheckboxChangeEvent, segment: string) => {
        const item = data.find(x => x.segment === segment);

        if (item) {
            item.unselected = !e.target.checked;
            setData([...data]);
        }
    }

    const checkAllChange = (e: CheckboxChangeEvent) => {

        setData(pre => {
            pre.forEach(item => {
                item.unselected = !e.target.checked;
            });
            return [...pre]
        })

    }

    useEffect(() => {
        if (markers && markers.length) {
            setCenter({ lat: markers[0].lat, lng: markers[0].long })
        }
    }, [markers])

    useEffect(() => {
        data.forEach(item => {
            const checkBox = document.getElementById(item.checkboxId);
            if (checkBox && checkBox.nextElementSibling) {
                const element = checkBox.nextElementSibling as HTMLElement;
                element.style.backgroundColor = item.markerColor;
                element.style.borderColor = item.markerColor;
            }
        })

        inintMarkers(data.filter(x => !x.unselected));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data])


    useEffect(() => {
        setData(props.data);
        inintMarkers(props.data);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.data]);

    return (
        <div className="dashboard-rapm-wrapper">
            <div className="header-bar">
                <p className="title">
                    {t("Dashboard.ttRAPM")}
                </p>
                {/* <Button type="text" className={`collapse-btn${isCollapse ? "" : " active"}`} shape="circle" onClick={() => setIsCollapse(pre => !pre)}>
                    <ArrowUpCircleIcon />
                    {
                        isCollapse ? t("Dashboard.lbShow") : t("Dashboard.lbHide")
                    }
                </Button> */}
            </div>

            <Collapse
                activeKey={isCollapse ? [] : ['1']}
                expandIconPosition="left"
            >
                <Panel header="" key="1">

                    <p className="map-title">
                        {t("Dashboard.desRAPM")}
                    </p>
                    <div id='map' style={{ width: '100%', height: 596 }}>
                        <GoogleMap
                            bootstrapURLKeys={{
                                key: GOOGLEMAP_API_KEY,
                                language: getCurrentLang()
                            }}
                            center={center}
                            zoom={GOOGLE_MAP_SETTINGS.zoom}
                            shouldUnregisterMapOnUnmount={true}
                            yesIWantToUseGoogleMapApiInternals={true}
                            options={{
                                zoomControl: GOOGLE_MAP_SETTINGS.zoomControl,
                                fullscreenControl: GOOGLE_MAP_SETTINGS.fullscreenControl
                            }}
                        >
                            {
                                markers.map((item, index) =>
                                    <Marker
                                        key={(item.postal_code + item.lat + item.long + index)}
                                        lat={item.lat}
                                        lng={item.long}
                                        data={item} />)
                            }
                        </GoogleMap>
                    </div>
                    <div className="select-wrapper">
                        <Checkbox checked={!data.some(x => x.unselected)} onChange={checkAllChange}>
                            {t("Dashboard.lbAll")}
                        </Checkbox>
                        {
                            data.map((item) => (
                                <Checkbox
                                    key={item.segment}
                                    checked={!item.unselected}
                                    onChange={(e) => checkBoxChange(e, item.segment)}
                                    id={item.checkboxId}>
                                    {item.segment}
                                </Checkbox>
                            ))
                        }
                    </div>
                </Panel>
            </Collapse>

        </div>
    )
}

interface MarkerProps {
    lat: number;
    lng: number;
    data: DashboardRAPMDataModel;
}

const Marker = React.memo((props: MarkerProps) => {
    const { t } = useTranslation();
    return (
        <Popconfirm
            title={<ModelContent {...props.data} />}
            okButtonProps={{ shape: "round", style: { padding: '0px 24px' } }}
            okText={t("Dashboard.btnDone")}
            className="marker-info-window"
            cancelButtonProps={{ style: { display: 'none' } }}
            icon={null}
        >
            <LocationIcon title={props.data.postal_code} className="marker-icon" style={{ width: 'auto', height: 20, color: props.data.color }} />
        </Popconfirm>
    )

})

const ModelContent = (props: DashboardRAPMDataModel) => {
    const { t } = useTranslation();
    return (
        <div className="marker-info-window">
            <p className="title">
                {t("Dashboard.lbPostalCode")}: {props.postal_code}
            </p>

            {
                props.data && props.data.map(item => (
                    <div className="item-wrapper">
                        <div className="item">
                            <span>
                                {t("Dashboard.lbAccountNumber")}: <span style={{ color: "#000000" }}>
                                    {item.account_number}</span>
                            </span>
                        </div>
                        <div className="item">
                            <span>
                                {t("Dashboard.lbOutstandingAmount")}: <span className="red-text">
                                    {AMOUNT_UTIL.convertNumericToFormattedAmount(item.outstanding_amount)}</span>
                            </span>
                        </div>
                        <div className="item">
                            <span>
                                {t("Dashboard.lbRiskAdjustedExposure")}: <span className="red-text">
                                    {AMOUNT_UTIL.convertNumericToFormattedAmount(item.risk_adjusted_exposure)}
                                </span>
                            </span>
                        </div>
                        <div className="item">
                            <span className="blue-text">
                                {item.segment}
                            </span>
                        </div>
                    </div>
                ))
            }

        </div>
    )
}


export default React.memo(DashboardRapmComponent)